import { render, staticRenderFns } from "./RoleRules.vue?vue&type=template&id=22fcb12a&scoped=true"
import script from "./RoleRules.vue?vue&type=script&lang=js"
export * from "./RoleRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcb12a",
  null
  
)

export default component.exports